import lzutf8 from 'lzutf8';

export function decompressArtifacts(artifacts) {
    return JSON.parse(lzutf8.decompress(lzutf8.decodeBase64(artifacts)));
}

export function compressArtifacts(artifacts) {
    return lzutf8.encodeBase64(lzutf8.compress(JSON.stringify(artifacts)));
}